import {METADATA, SIDE_POSITIONS} from "../../constants";
import AccessoryCommon from "./accessoryCommon";
import {Shower} from "../../parts/shower";
import {ShowerTubCombo} from "../../parts/showerTubCombo";

export default class GrabBar extends AccessoryCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'grab_bar';
    this.partName = 'Grab Bar';
    this.translateId = "visualizer.bathroom.accessories.grab_bar";
    this.visible = true;
    this.canBeDisabled = true;
    if (isChild) {
      this.layerPositions = {
        [SIDE_POSITIONS[0]]: null,
        [SIDE_POSITIONS[1]]: null,
        [SIDE_POSITIONS[2]]: null,
      };
    }
  }

  load(dbFeature) {
    dbFeature.metaData["layerPosition"] = dbFeature.metaData["Side"] ? dbFeature.metaData["Side"][0] : METADATA.LeftSide;
    if (!dbFeature.metaData["Placement"]) {
      dbFeature.metaData["Placement"] = ["Default"];
    }
    const partNumber = dbFeature.metaData["layerPosition"] !== SIDE_POSITIONS[1] ? 1 : 2;
    return super.load_(dbFeature, new GrabBar(false, partNumber),
      true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  disabledClick() {
    if (!this.disabled && this.activeFeature) {
      this.activeFeature.handleClick() // check soapDish
    }
  }

  availableFeatures(features) {
    return features.filter(feature => feature.partNumber === 1)
  }

  handleClick() { // "this" is feature!! not the feature group
    super.handleClick();
    const parent = this.getParent();
    const accessoriesParent = parent.getParent();
    const showerParent = accessoriesParent.layout.parts[Shower.id];
    const showerSize = showerParent.showerSize();
    if (showerSize !== "60" && parent.activeFeature) {
      parent.layerPositions[parent.activeFeature.metaData["layerPosition"]] = parent.activeFeature;
    }
    // parent.checkRelatedFeatureGroupPositions(this.metaData["layerPosition"]);
  }

  checkCenterGrabWall(clickedPosition) { // L or R and C can't be together
    if (!clickedPosition) {
      return
    }
    Object.keys(this.layerPositions).forEach(position => {
      if (clickedPosition === "C") {
        if (position !== "C") {
          this.layerPositions[position] = null;
        }
      } else if (position === "C") {
        this.layerPositions[position] = null;
      }
    })
  }

  checkCurrentPositions(position) {
    const feature = this.layerPositions[position];
    if (!feature) {
      return
    }
    const nameSplitted = feature.dbFeature.sharedFeatureName.split(" ");
    const size = nameSplitted[nameSplitted.length - 1] ? nameSplitted[nameSplitted.length - 1].replace("in", "") : "";
    const newPosition = position === SIDE_POSITIONS[0] ? SIDE_POSITIONS[1] : SIDE_POSITIONS[0];
    if (!size || !this.layerPositions[newPosition]) {
      return
    }
    if (this.layerPositions[newPosition]) {
      const nameSplitted2 = this.layerPositions[newPosition].dbFeature.sharedFeatureName.split(" ");
      const size2 = nameSplitted2[nameSplitted2.length - 1] ? nameSplitted2[nameSplitted2.length - 1].replace("in", "") : "";
      if (!size || (+size2 === 12 && +size === 12)) { // last chance to keep other side layer
        return;
      }
    }
    this.layerPositions[newPosition] = null;
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const grabParent = this.getParent();
    const showerParent = grabParent.layout.parts[Shower.id];
    const showerComboParent = grabParent.layout.parts[ShowerTubCombo.id];
    const walkInTubIsActive = showerParent && showerComboParent && showerParent.showerTubComboIsActive()
      && showerComboParent.bottomTub === "walk_in_tub";
    conditions.push({
      propName: "Placement",
      propValue: walkInTubIsActive ? "WIT" : "Default"
    })
    return conditions;
  }

  showLayerPositionsModal(forFeature) {
    const showerParent = this.getParent().layout.parts[Shower.id];
    if (showerParent.showerSize() !== "60") {
      return false
    }
    return super.showLayerPositionsModal(forFeature)
  }

}
